import React, { useState } from 'react';
import DateRangeCalendar from './Calendar';
import { Button } from './ui/Button';
import toast from 'react-hot-toast';

export const ExportLedgersModal: React.FC<{
  onClose: () => void;
  onExport: (startDate: Date, endDate: Date) => void;
  isExporting: boolean;
}> = ({ onClose, onExport, isExporting }) => {
  // Blank by default until user clicks
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleDownload = () => {
    if (!startDate || !endDate) {
      toast.error('Please select a date range');
      return;
    }
    onExport(startDate, endDate);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-2 text-gray-900">Download Remittance Data</h2>
      <p className="text-sm text-gray-500 mb-6">
        Select a date range to download the remittance data.
      </p>

      <div className="flex justify-center mb-8">
        <DateRangeCalendar
          startDate={startDate}
          endDate={endDate}
          onChange={(start, end) => {
            setStartDate(start);
            setEndDate(end);
          }}
        />
      </div>

      <div className="flex justify-end gap-3 pt-6 border-t border-gray-100">
        <Button variant="ghost" onClick={onClose} disabled={isExporting}>
          Cancel
        </Button>
        <Button onClick={handleDownload} disabled={isExporting} className="px-8">
          {isExporting ? 'Downloading...' : 'Download'}
        </Button>
      </div>
    </div>
  );
};
